define('runTemplateTableTabController',[
    'module',
    'app',
    'underscore',
    'backbone',
    'runTemplateTableTabView'
], function(
    module,
    App,
    _,
    Backbone,
    TableTabView
) {
    'use strict';

    var TableTabController = {
        showTableTab: function(region, runTemplateModel) {
            this.region = region;
            this.model = runTemplateModel;
            this.view = new TableTabView({
                model: runTemplateModel
            });
            this.view.listenTo(this.view, 'welltemplate:filteredDetailRow', _.bind(this.filteredDetailRow, this));
            this.view.listenTo(this.view, 'welltemplate:filteredDetailColumn', _.bind(this.filteredDetailColumn, this));
            this.view.listenTo(this.view, 'welltemplate:filteredDetailItem', _.bind(this.filteredDetailItem, this));

            region.show(this.view);
        },

        filteredDetailRow: function(row) {
            App.navigate('runtemplates/'+this.view.model.get('secId')+'/details/row/' + row, {trigger: true});
        },

        filteredDetailColumn: function(column) {
            if (column) {
                App.navigate('runtemplates/'+this.view.model.get('secId')+'/details/column/' + column, {trigger: true});
            } else {
                App.navigate('runtemplates/'+this.view.model.get('secId')+'/details', {trigger: true});
            }
        },

        filteredDetailItem: function(row, column) {
            App.navigate('runtemplates/'+this.view.model.get('secId')+'/details/row/'+row+'/column/' + column, {trigger: true});
        }
    };

    module.exports = TableTabController;
});
